var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#030659"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.387 7H16.0996C15.0886 7 14.1189 7.48367 13.404 8.34461C12.689 9.20554 12.2874 10.3732 12.2874 11.5908V14.3452H10V18.0178H12.2874V25.3631H15.3372V18.0178H17.6245L18.387 14.3452H15.3372V11.5908C15.3372 11.3473 15.4175 11.1137 15.5605 10.9415C15.7035 10.7693 15.8974 10.6726 16.0996 10.6726H18.387V7Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook2);
export default __webpack_public_path__ + "static/media/facebook-2.35c4964a721cc59343a508e85feab0f6.svg";
export { ForwardRef as ReactComponent };